import "./Course.css"
import { NavBar, Footer, Cource } from "../../Components/ExportComponents";
import { act, useEffect, useState } from "react";
import courseImg from "../../Photos/Courses/Courses3.png";
import person from "../../Photos/Icons/person.png";
import { FaArrowRight } from 'react-icons/fa';
import time from "../../Photos/Icons/time.png"
import certificate from "../../Photos/Icons/Certificate.png"
import { Link } from "react-router-dom";


import { useParams } from "react-router-dom";

const CoursesPreview = ({ CoursesDetails }) => {

    const { id } = useParams();


    const CourseDetailSingle = CoursesDetails.filter(course => course.courseId === id);
    // console.log(CourseDetailSingle[0])
    // document.title = CourseDetailSingle[0].title;
    document.title = "Courses | Scaleup Academy"
    const [coursesData, setCoursesData] = useState({
        time: "6 Day a week (Sunday - Friday)",
        timeDay: ["Morning", "Day", "Evening"],
        desc1: "Certificate of Completion",
        desc2: "Intern & Job Placement Support",
        desc3: "Career Mentorship & Portfolio Development"
    });
    const [active, setActive] = useState(CourseDetailSingle[0].courseType[0]);
    useEffect(() => {
        if (active === "2.5") {
            setCoursesData({
                time: "6 Day a week (Sunday - Friday)",
                timeDay: ["Morning", "Day", "Evening"],
                desc1: "Certificate of Completion",
                desc2: "Intern & Job Placement Support",
                desc3: "Career Mentorship & Portfolio Development"
            })
        }
        else if (active === "1") {
            setCoursesData({
                time: "2 Day a week (Sunday - Monday)",
                timeDay: ["Morning", "Evening"],
                desc1: "Certificate of Completion",
                desc2: "Intern & Job Placement Support",
                desc3: "Career Mentorship & Portfolio Development"
            })
        }
    }, [active]);

    console.log(CourseDetailSingle)


    return (
        <>

            <NavBar />
            <div className="coursePreviewPage">
                <div className="courseDetails">
                    <div className="courseImageBox">
                        <div className='linear-gradient'></div>
                        <img src={CourseDetailSingle[0].img} alt="course" />
                    </div>


                    <div className="courseDescBox">
                        <div className="textDesc">
                            {CourseDetailSingle[0].title}
                        </div>
                        <div className="hrLine"></div>
                        <div className="chooseMonth">
                            {CourseDetailSingle[0].courseType.map((txt) =>
                                <button onClick={() => setActive(txt)} className={active === txt && "active"}>{txt} </button>
                            )}

                        </div>
                        <div className="courseDescIntro">

                            <div className="iconText">
                                <div className="first">

                                    <img src={time} alt="icon" />
                                    <p>{CourseDetailSingle[0].courseDescType[0].title}</p>
                                </div>
                                <div className="second">
                                    <div className="box"></div>
                                    <div className="Times">
                                        {CourseDetailSingle[0].courseDescType[0].classTime.map((text, index) =>
                                            <p key={index}>{text}</p>
                                        )}

                                    </div>
                                </div>
                            </div>
                            <div className="iconText">
                                <img src={certificate} alt="icon" />
                                <p>{coursesData.desc1}</p>
                            </div>
                            <div className="iconText">
                                <img src={person} alt="icon" />
                                <p>{coursesData.desc2}</p>
                            </div>
                            <div className="iconText">
                                <img src={person} alt="icon" />
                                <p>{coursesData.desc3}</p>
                            </div>
                        </div>

                        <Link to={"/contact/enrollNow"}>
                            <span>Enroll Now</span>
                            <span>Enroll Now</span>
                        </Link>
                    </div>
                </div>
                <div className="coursesDescriptionDetails">
                    <div className="courseTitle">
                        Description
                    </div>
                    <div className="doThis">
                        {CourseDetailSingle[0].largeDesc.map((txt, index) =>
                            <p key={index}>{txt}</p>
                        )}

                        {/* This course offers a comprehensive introduction to visual communication, combining design theory, software instruction, project-based learning, and portfolio building. You’ll explore how to use tools like Adobe Photoshop, Illustrator, and Figma to craft impactful visuals for print and digital media. By the end of the program, you’ll possess the skills and confidence to start working in branding, multimedia, web design, and creative roles. */}
                    </div>

                    {/* Skills Learn  */}
                    {CourseDetailSingle[0].skillsLearn &&
                        <div className="whatCanYoDo">
                            <h1>Skills You’ll Learn</h1>
                            <ul>
                                {CourseDetailSingle[0].skillsLearn.map((txt, index) =>
                                    <li key={index}>{txt}</li>
                                )}
                                {/* <li>Work as a Graphic Designer or Visual Communicator in creative agencies or companies.</li>
                            <li>Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.</li>
                            <li>Work on marketing campaigns, product packaging, and print/digital advertisements.</li>
                            <li>Pursue further specialization in UI/UX or Motion Graphics and More.</li> */}
                            </ul>
                        </div>
                    }
                    {CourseDetailSingle[0].benefits &&
                        <div className="whatCanYoDo">
                            <h1>Benefits of CCNA Training</h1>
                            <ul>
                                {CourseDetailSingle[0].benefits.map((txt, index) =>
                                    <li key={index}>{txt}</li>
                                )}
                                {/* <li>Work as a Graphic Designer or Visual Communicator in creative agencies or companies.</li>
                            <li>Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.</li>
                            <li>Work on marketing campaigns, product packaging, and print/digital advertisements.</li>
                            <li>Pursue further specialization in UI/UX or Motion Graphics and More.</li> */}
                            </ul>
                        </div>
                    }

                    {CourseDetailSingle[0].academyBenefits &&
                        <div className="whatCanYoDo">
                            <h1>Benefits of CCNA Training at Scaleup Academy</h1>
                            <ul>
                                {CourseDetailSingle[0].academyBenefits.map((txt, index) =>
                                    <li key={index}>{txt}</li>
                                )}
                                {/* <li>Work as a Graphic Designer or Visual Communicator in creative agencies or companies.</li>
                            <li>Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.</li>
                            <li>Work on marketing campaigns, product packaging, and print/digital advertisements.</li>
                            <li>Pursue further specialization in UI/UX or Motion Graphics and More.</li> */}
                            </ul>
                        </div>
                    }


                    {CourseDetailSingle[0].whoCanJoin &&
                        <div className="whatCanYoDo">
                            <h1>Who Can Join?</h1>
                            <ul>
                                {CourseDetailSingle[0].whoCanJoin.map((txt, index) =>
                                    <li key={index}>{txt}</li>
                                )}
                                {/* <li>Work as a Graphic Designer or Visual Communicator in creative agencies or companies.</li>
                            <li>Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.</li>
                            <li>Work on marketing campaigns, product packaging, and print/digital advertisements.</li>
                            <li>Pursue further specialization in UI/UX or Motion Graphics and More.</li> */}
                            </ul>
                        </div>
                    }

                    {/* <p>Our curriculum is researched, developed, and updated by understanding the global scope and job demands. Conducted by industry-leading expert instructors, the program offers more than 85% of an in-depth practical approach backed by essential theoretical frameworks. */}
                    {/* </p> */}
                    <div className="whatCanYoDo">
                        <h1>What You Can Do After This Course:</h1>
                        <ul>
                            {CourseDetailSingle[0].whatNext.listDesc.map((txt, index) =>
                                <li key={index}>{txt}</li>
                            )}
                            {/* <li>Work as a Graphic Designer or Visual Communicator in creative agencies or companies.</li>
                            <li>Start freelancing projects on platforms like Fiverr, Upwork, or Freelancer.</li>
                            <li>Work on marketing campaigns, product packaging, and print/digital advertisements.</li>
                            <li>Pursue further specialization in UI/UX or Motion Graphics and More.</li> */}
                        </ul>
                    </div>
                </div>

                <div className="moreCourses">
                    <div className="title">
                        <div className="sectionTitle">
                            <FaArrowRight aria-label="Scaleup Academy" className="ArrowIcons" />
                            <p>More Courses</p>
                        </div>
                    </div>

                    <div className="listCoursesPreview">
                        <div className="wholeCourse">
                            <Cource details={CoursesDetails[0]} />
                            <Cource clsName={"fixImage"} details={CoursesDetails[1]} />
                            <Cource clsName={"fixImage"} details={CoursesDetails[2]} />
                            <Cource details={CoursesDetails[3]} />
                            <Cource details={CoursesDetails[4]} />
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default CoursesPreview;